<template>
  <DuoUnits/>
</template>

<script>
// @ is an alias to /src
import DuoUnits from '@/components/DuoUnits.vue'

export default {
  components: {
    DuoUnits
  }
}
</script>
